import { NgModule } from '@angular/core';
import { RestoreCartComponent } from './restore-cart.component';
import { CommonModule } from '@angular/common';
import { CmsConfig, ConfigModule } from '@spartacus/core';

@NgModule({
  declarations: [RestoreCartComponent],
  imports: [
    CommonModule,
    ConfigModule.withConfig({
      cmsComponents: {
        RestoreCartComponent: {
          component: RestoreCartComponent,
        },
      },
    } as CmsConfig),
  ],
})
export class RestoreCartModule {}
